export default {
  "l10n": {
    "currency": '\u20ac',
    "date": {
      "months": {
        "full": ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
        "abbr": ["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic."]
      },
      "days": {
        "full": ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"],
        "abbr": ["do.","lu.","ma.","mi.","ju.","vi.","sá."]
      },
      "patterns": {
        "longDate": "dddd, D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateMedium": "dddd, D [de] MMMM - HH[:]mm [h]",
        "dateLarge": "dddd, D [de] MMMM [a las] HH[:]mm:ss",
        "timeShort": "HH:mm",
        "timeMedium": "DD[/]MM HH:mm"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-n S", "n S"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "plural": "nplurals=2; plural=(n != 1);",
      "ordinal": function(number) { return number + (number === 1 ? '°' : '°'); }
    }
  },
  "translations": {
    "messages": {
  " CASH ": [
    null,
    ""
  ],
  "!action:Deposit": [
    null,
    "Depositar"
  ],
  "!desc:BetRefundOffer": [
    null,
    "Primera apuesta rembolsada hasta 100 €<br /><br />Para darte la bienvenida a Winamax, te ofrecemos dos ofertas: un bono de hasta 200 € y una apuesta reembolsada de hasta 100 €.<br /><br />Las dos ofertas son acumulables y se activan automáticamente con tu primer depósito en la plataforma.<br /><br />Bono de hasta 200 €<br /><br />Si tu primera apuesta deportiva efectuada en Winamax es perdedora, recibirás una apuesta gratis por el mismo valor. Limitado al importe de tu primer depósito y hasta un máximo de 100 €.<br /><br />Por ejemplo: haces un primer depósito de 50 € en Winamax y los apuestas a la victoria del Atlético Madrid contra la Juventus. Si el Atlético no gana, recibirás una apuesta gratis de 50 € en tu cuenta Winamax."
  ],
  "!desc:BetRefundOffer100": [
    null,
    ""
  ],
  "!desc:CondBetRefundOffer": [
    null,
    "."
  ],
  "!desc:CondFirstDeposit": [
    null,
    "."
  ],
  "!desc:DefaultLandingContent": [
    null,
    ""
  ],
  "!desc:DefaultLandingContentES": [
    null,
    "<h1>Únete a Winamax gratuitamente</h1>\n<p>\nRegístrate ahora para beneficiarte de excepcionales ventajas.<br/><br/>\n<div >\n  <ul style=\"margin-left: 20px\">\n      <li>\n          <b> Apuestas deportivas </b> <br/>\n          \n          Crea tu apuesta y obtén una cuota totalmente personalizada con MyMatch.<br/><br/>\n      </li><li>\n          <b>Los Freerolls: 12 torneos gratuitos todos los días</b><br/>\n          \n          Descubre nuestro software de Poker participando en estos torneos gratuitos, ¡hay 1.500€ en premios todos los días! <br/><br/>\n      </li><li class=\"hide-for-small\">     \n          <b>Sitio web seguro al 100% </b><br/>\n          Juega de forma segura en nuestro software autorizado por la Dirección General de Ordenación del Juego (DGOJ). <br/><br/>\n      </li>\n  </ul>\n</div>\n</p>"
  ],
  "!desc:DefaultLandingMobileContent": [
    null,
    ""
  ],
  "!desc:DefaultLandingPageTitleES": [
    null,
    "Únete a Winamax y disfruta de las mejores cuotas del mercado y una experiencia única jugando al póker online"
  ],
  "!desc:DefaultLandingTitleES": [
    null,
    "La mejor oferta en apuestas deportivas y poker"
  ],
  "!desc:SpecialOfferLandingContent": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingMobileContent": [
    null,
    ""
  ],
  "!placeholder:dd": [
    null,
    "dd"
  ],
  "!placeholder:mm": [
    null,
    "mm"
  ],
  "!placeholder:yy": [
    null,
    "aa"
  ],
  "!placeholder:yyyy": [
    null,
    "aaaa"
  ],
  ", if you lost": [
    null,
    ""
  ],
  "1st bet refunded up to €100": [
    null,
    "Primera apuesta reembolsada hasta 100 €"
  ],
  "A photo of the back of your ID document will also be required to validate your account.": [
    null,
    "Ahora necesitamos que nos envíes una foto de la parte trasera de tu DNI para poder validar tu cuenta."
  ],
  "A receipt for your rent": [
    null,
    "Un justificante de alquiler"
  ],
  "Above": [
    null,
    "Subir"
  ],
  "Acceptable ID": [
    null,
    "Documentos de identidad válidos"
  ],
  "Acceptable formats: %1$s.": [
    null,
    "Formatos aceptados: %1$s."
  ],
  "Acceptable proof of address documents": [
    null,
    "Justificantes de domicilio válidos"
  ],
  "Account already exist": [
    null,
    "Ya existe esta cuenta"
  ],
  "Account creation complete": [
    null,
    "Creación de cuenta completada"
  ],
  "Account creation: complete.<br />That's what<br />we're talking about!": [
    null,
    "Cuenta creada.<br />¡Así se hace!<br />"
  ],
  "Account number": [
    null,
    "Número de cuenta"
  ],
  "Activation code": [
    null,
    "Activation code"
  ],
  "Add a bank card": [
    null,
    "Añadir una tarjeta"
  ],
  "Add my bank card": [
    null,
    "Añadir tarjeta"
  ],
  "Add my bank card details": [
    null,
    "Introducir datos"
  ],
  "Address details": [
    null,
    "Información adicional"
  ],
  "All countries": [
    null,
    "Países"
  ],
  "An error has occured when checking your CAPTCHA score. Please try again later.": [
    null,
    "Se ha producido un error mientras comprobábamos el CAPTCHA. Por favor, inténtalo de nuevo."
  ],
  "Analysis": [
    null,
    "Analizando"
  ],
  "Automatic withdrawal": [
    null,
    "Reintegro automático"
  ],
  "Automatic withdrawal threshold": [
    null,
    ""
  ],
  "BOOM! You can start playing!": [
    null,
    "¡Bum! Ya puedes empezar a jugar"
  ],
  "Back": [
    null,
    "Atrás"
  ],
  "Back to homepage": [
    null,
    "Volver al inicio"
  ],
  "Bank": [
    null,
    "Banco"
  ],
  "Bank accounts from this country are not accepted on Winamax": [
    null,
    "Winamax no acepta las cuentas bancarias domiciliadas en este país."
  ],
  "Bank card number": [
    null,
    "Número de la tarjeta"
  ],
  "Bank code": [
    null,
    "Código BIC"
  ],
  "Bank office": [
    null,
    "Código de sucursal"
  ],
  "Before any action even made on our site, we offer you your initial deposit in Freebets, up to €100.": [
    null,
    ""
  ],
  "Beginner": [
    null,
    ""
  ],
  "Beginner profile token": [
    null,
    ""
  ],
  "Beneficiary": [
    null,
    "Beneficiario"
  ],
  "Bet on sports": [
    null,
    "Realizar apuestas deportivas"
  ],
  "Betting limit - Poker": [
    null,
    ""
  ],
  "Betting limit - Sport betting": [
    null,
    ""
  ],
  "Birth date": [
    null,
    "Fecha de nacimiento"
  ],
  "Birth name": [
    null,
    ""
  ],
  "Bonus up to €250": [
    null,
    "Bono de hasta 200 €"
  ],
  "Boom!": [
    null,
    "¡Bum!"
  ],
  "By ticking this box, you agree that you have read and accepted our": [
    null,
    "Al marcar esta casilla, declaras haber leído y aceptado expresamente nuestros"
  ],
  "CAPTCHA score error. Please try again. You will automatically be redirected to the Winamax website. (%1$s)": [
    null,
    "Error en CAPTCHA. Por favor, inténtalo de nuevo. Serás redirigido automáticamente a la página de Winamax (%1$s)"
  ],
  "Card number": [
    null,
    "Número de tarjeta"
  ],
  "Change address": [
    null,
    "Cambiar dirección"
  ],
  "Change my deposit limit": [
    null,
    "Cambiar mi límite de depósito"
  ],
  "Change my limit": [
    null,
    "Cambiar el límite"
  ],
  "Change your account details in order to receive your activation code by post.": [
    null,
    "activation code"
  ],
  "Check that your bank card information is accurate and complete the cryptogram.": [
    null,
    "Comprueba que los datos de la tarjeta son correctos e introduce el código CVV."
  ],
  "Choose a deposit method in order to make your first deposit.": [
    null,
    "Elige un método para hacer tu primer depósito."
  ],
  "Choose a deposit method.": [
    null,
    "Elegir un método de depósito"
  ],
  "Choose the amount of your first deposit in order to start playing.": [
    null,
    "Elige el importe del primer depósito para empezar a jugar"
  ],
  "Choose the amount you wish to deposit in order to continue playing.": [
    null,
    "Elige el importe que deseas depositar para seguir jugando"
  ],
  "Choose the maximum amount you wish to deposit per month.": [
    null,
    ""
  ],
  "Choose the maximum amount you wish to deposit per week.": [
    null,
    "Elige el importe máximo que deseas depositar por semana."
  ],
  "Choose the profile that best suits your playing style! You can also change the values manually.": [
    null,
    ""
  ],
  "Choose which bank card you want to use to make a deposit.": [
    null,
    "Elige la tarjeta que quieres usar para el depósito"
  ],
  "Choose your country code": [
    null,
    "Selecciona el prefijo telefónico"
  ],
  "Choose your limit well in order to take advantage of your <b>first bet refunded up to €100</b>": [
    null,
    "Elige tu límite para disfrutar de <b>tu primera apuesta reembolsada hasta 100 € </b>"
  ],
  "Choose your username, but choose well!!<br />You need to have a kick-ass username to stand out in society.": [
    null,
    "Piénsatelo y elige bien.<br />Es importante tener un nick con gancho para briller en sociedad."
  ],
  "City": [
    null,
    "Ciudad"
  ],
  "Click & drag your file here": [
    null,
    "Clic y arrastra tu archivo"
  ],
  "Close": [
    null,
    "Cerrar"
  ],
  "Come and take a seat": [
    null,
    "Ven y siéntate"
  ],
  "Complete registration now": [
    null,
    ""
  ],
  "Confirm limit": [
    null,
    "Confirmar límite"
  ],
  "Confirm my details": [
    null,
    "Confirmar mis datos"
  ],
  "Confirm my limit": [
    null,
    "Confirmar el límite"
  ],
  "Confirm your details in order to receive a new activation code by post.": [
    null,
    "Confirm your details in order to receive a new activation code by post.\n"
  ],
  "Continue": [
    null,
    "Continuar"
  ],
  "Continue my deposit": [
    null,
    "Continuar mi depósito"
  ],
  "Continue with PayPal": [
    null,
    "Continuar con PayPal"
  ],
  "Country": [
    null,
    "País"
  ],
  "Country of birth": [
    null,
    "País de nacimiento"
  ],
  "Country of residence": [
    null,
    "País de residencia"
  ],
  "Create my account": [
    null,
    "Crear mi cuenta"
  ],
  "Creation": [
    null,
    "Creando"
  ],
  "Cryptogram": [
    null,
    "CVV"
  ],
  "Deposit": [
    null,
    "Depósito"
  ],
  "Deposit limit": [
    null,
    "Límite de depósito"
  ],
  "Deposit on my account": [
    null,
    "Depositar en mi cuenta"
  ],
  "Deposit on your Winamax account by bank transfer": [
    null,
    "Hacer un depósito en tu cuenta Winamax por transferencia"
  ],
  "Deposit on your account with Neteller.": [
    null,
    "Depositar con Neteller"
  ],
  "Deposit with Moneybookers/Skrill.": [
    null,
    "Depositar con Moneybookers/Skrill."
  ],
  "Document": [
    null,
    "Documento"
  ],
  "Document number": [
    null,
    "Número de documento"
  ],
  "Don't forget to send us your ID to validate your account and withdraw your winnings.": [
    null,
    "No olvides enviar to documento de identidad para poder validar tu cuenta y retirar tus ganancias."
  ],
  "Driver's licence": [
    null,
    "Permiso de conducir"
  ],
  "Driver's license": [
    null,
    "Carné de conducir"
  ],
  "Driver's license: whole document with photo or front and back sides": [
    null,
    "Carné de conducir: dos caras"
  ],
  "Edit email/phone number": [
    null,
    "Modificar correo/número de teléfono"
  ],
  "Email": [
    null,
    "Correo"
  ],
  "Enter a different amount": [
    null,
    "Introducir otra cantidad"
  ],
  "Enter amount": [
    null,
    "Introducir cantidad"
  ],
  "Enter my information": [
    null,
    "Introducir mis datos"
  ],
  "Enter the activation code sent to you by post.": [
    null,
    "Enter the activation code sent to you by post.\n"
  ],
  "Enter the code sent by text message to %1$s to verify your phone number.": [
    null,
    "Introduce el código enviado al %1$s para verificar tu número de teléfono."
  ],
  "Experienced": [
    null,
    ""
  ],
  "Experienced profile token": [
    null,
    ""
  ],
  "Expiry date": [
    null,
    "Fecha de caducidad"
  ],
  "Feel free to discover the platform at a later date if you so wish.": [
    null,
    "Si te apetece descubrir la plataforma más adelante, podrás hacerlo en otro momento."
  ],
  "Female": [
    null,
    "Mujer"
  ],
  "Fill in my details": [
    null,
    "Completar mis datos"
  ],
  "Fill out the following form. Or directly fill out the informations with Paypal": [
    null,
    "Completa el siguiente formulario. O completa directamente tu información con Paypal"
  ],
  "Fill out the form with your bank card information.": [
    null,
    "Completa la información de la tarjeta"
  ],
  "First deposit": [
    null,
    "Primer depósito"
  ],
  "First name": [
    null,
    "Nombre"
  ],
  "For a Spanish nationality, you must supply us with a DNI and not a NIE": [
    null,
    "Si eres de nacionalidad española, deberás introducir un DNI y no un NIE"
  ],
  "For a foreign nationality, you must supply us with a NIE and not a DNI": [
    null,
    "Si eres de nacionalidad distinta a la española, deberás introducir un NIE y no un DNI"
  ],
  "Free registration": [
    null,
    "Registro gratuito"
  ],
  "Full name on card": [
    null,
    "Nombre del titular"
  ],
  "GG!<br />Your account has<br />been validated!": [
    null,
    "¡Todo listo!<br /> Ya puedes empezar a jugar"
  ],
  "Gambling is prohibited for minors": [
    null,
    "Los juegos de azar están prohibidos \npara menores de 18 años"
  ],
  "General Terms and Conditions": [
    null,
    "Términos y condiciones generales"
  ],
  "Health card: front and back": [
    null,
    "Tarjeta sanitaria: dos caras"
  ],
  "Hold on": [
    null,
    "Espera"
  ],
  "I accept the ": [
    null,
    "Acepto el "
  ],
  "I agree to gain access to all": [
    null,
    "Acepto participar en todas las promociones de"
  ],
  "I have not received my code": [
    null,
    "No he recibido el código"
  ],
  "I need a new code": [
    null,
    "Necesito un código nuevo"
  ],
  "I want to receive offers and news": [
    null,
    ""
  ],
  "I will deposit later": [
    null,
    "Depositar más tarde"
  ],
  "I will send it at a later time": [
    null,
    "Lo enviaré más tarde"
  ],
  "I would like to receive the newsletter and be kept up to date on all the latest bonuses and promotions": [
    null,
    ""
  ],
  "IBAN": [
    null,
    "IBAN"
  ],
  "ID card: front and back": [
    null,
    "DNI: dos caras"
  ],
  "ID card: front side": [
    null,
    "DNI: parte delantera"
  ],
  "Identity card": [
    null,
    "Documento de identidad"
  ],
  "Identity not verified": [
    null,
    "Identidad no válida"
  ],
  "If you are not resident in Germany, you can register on": [
    null,
    ""
  ],
  "Important! Make sure you add the folloing reference for your transfer:": [
    null,
    "¡Importante! Introduce esta referencia para la transferencia."
  ],
  "In 30 seconds": [
    null,
    "En 30 segundos"
  ],
  "In order to be able to play for real money, you must submit an ID and proof of address.": [
    null,
    "Para poder jugar con dinero real, debes enviar un documento de identidad y una prueba de residencia."
  ],
  "In order to make your deposit, add your bank card or any other deposit method.": [
    null,
    "Para realizar tu depósito, añade una tarjeta o elige otro método de pago"
  ],
  "In order to make your first deposit, add your bank card or any other deposit method.": [
    null,
    "Para realizar tu primer depósito, añade una tarjeta o elige otro método de pago."
  ],
  "In order to play for real money, you must send us a proof of address.": [
    null,
    "Para poder jugar con dinero real, debes enviar una prueba de residencia."
  ],
  "In order to play for real money, you must send us an ID.": [
    null,
    "Para poder jugar con dinero real, debes enviar un documento de identidad."
  ],
  "In order to validate your account, you must upload a photo of your ID.": [
    null,
    "Para validar tu cuenta, necesitas enviarnos una foto de tu documento de identidad."
  ],
  "Incorrect format in this field": [
    null,
    "Formato incorrecto."
  ],
  "Incorrect tax code": [
    null,
    "DNI / NIE incorrecto"
  ],
  "Incorrect value in this field, the department does not match the city.": [
    null,
    "Valor incorrecto, la región no se corresponde con la ciudad."
  ],
  "Invalid NIE support number format. This must start with the letter \"E\" or \"C\" and be followed by 8 numbers.": [
    null,
    "Formato de NIE inválido. Debe empezar por una E o una C, seguido de 8 cifras."
  ],
  "Invalid phone number format.": [
    null,
    "Formato de número de telefóno es inválido"
  ],
  "It seems there is a connection problem": [
    null,
    "Parece que hay un problema de conexión."
  ],
  "It's time to get serious": [
    null,
    "Llegó el momento de ponerse serios"
  ],
  "Join Winamax and take advantage of our welcome offer!": [
    null,
    "¡Únete a Winamax y benefíciate de nuestra oferta de bienvenida!"
  ],
  "Keep an <br />eye on your<br />dough!": [
    null,
    "¡Vigilia<br />la pasta!"
  ],
  "Last name": [
    null,
    "Primer Apellidos"
  ],
  "Last<br />sprint!": [
    null,
    "¡Ya casi <br />hemos terminado!"
  ],
  "Leave": [
    null,
    "Salir"
  ],
  "Loading...": [
    null,
    "Cargando..."
  ],
  "Log in": [
    null,
    "Conectarse"
  ],
  "Make a deposit": [
    null,
    "Hacer un depósito"
  ],
  "Male": [
    null,
    "Hombre"
  ],
  "Maximum amount per month": [
    null,
    ""
  ],
  "Maximum amount per week": [
    null,
    "Importe máximo por semana"
  ],
  "Missing application initialization parameters. Please try again.": [
    null,
    "Faltan los parámetros de inicio de la aplicación. Por favor, inténtalo de nuevo."
  ],
  "Moneybookers email": [
    null,
    "Correo de Moneybookers"
  ],
  "Must contain at least 3 of the following characters: (0-9), (a-z), (A-Z) and symbols (ex @, !, #, $).": [
    null,
    "Debe contener al menos 3 de los caracteres siguientes: (0-9), (a-z), (A-Z) y símbolos (ex @, !, #, $)."
  ],
  "NIE number": [
    null,
    "Número de soporte del NIE"
  ],
  "Nationality": [
    null,
    "Nacionalidad"
  ],
  "Neteller Secure ID": [
    null,
    "ID de seguridad Neteller"
  ],
  "Neteller account": [
    null,
    "Cuenta Neteller"
  ],
  "No godfather found for this code": [
    null,
    ""
  ],
  "No minors": [
    null,
    "Prohibido a los menores de edad"
  ],
  "Not connected": [
    null,
    "No estás conectado"
  ],
  "Ok": [
    null,
    "Vale"
  ],
  "Oops,": [
    null,
    "¡Vaya!"
  ],
  "Open your account": [
    null,
    "Creación de cuenta"
  ],
  "Optional": [
    null,
    "Opcional"
  ],
  "Other deposit methods": [
    null,
    "Otros métodos de depósito"
  ],
  "Other suggestions": [
    null,
    "Otras sugerencias"
  ],
  "Our bank details for your transfer:": [
    null,
    "He aquí nuestros datos bancarios para que realices la transferencia:"
  ],
  "Passport": [
    null,
    "Pasaporte"
  ],
  "Passport: whole page with photo": [
    null,
    "Pasaporte: página completa con fotografía"
  ],
  "Password": [
    null,
    "Contraseña"
  ],
  "Per month": [
    null,
    ""
  ],
  "Per week": [
    null,
    "Por semana"
  ],
  "Personal information": [
    null,
    "Información personal"
  ],
  "Phone number": [
    null,
    "Número de teléfono"
  ],
  "Phone, internet, water, gas or electricity bills": [
    null,
    "Factura de gas, agua, internet, electricidad..."
  ],
  "Place of birth": [
    null,
    "Lugar de nacimiento"
  ],
  "Play on the app !": [
    null,
    "¡Jugar en la app!"
  ],
  "Play poker": [
    null,
    "Jugar al póker"
  ],
  "Play time - Poker": [
    null,
    ""
  ],
  "Poker Terms and Conditions": [
    null,
    "Reglamento de póker"
  ],
  "Postal address": [
    null,
    "Dirección"
  ],
  "Postal code": [
    null,
    "Código postal"
  ],
  "Privacy Policy": [
    null,
    "Política de privacidad y de confidencialidad"
  ],
  "Processing": [
    null,
    "Procesando"
  ],
  "Protect your behind!": [
    null,
    "¡Cúbrete las espaldas!"
  ],
  "Protect<br />your<br />behind!": [
    null,
    "¡Cúbrete<br />las<br />espaldas!"
  ],
  "Province": [
    null,
    "Comunidad / Provincia"
  ],
  "RIB key": [
    null,
    "Código de control"
  ],
  "Reference": [
    null,
    "Referencia"
  ],
  "Referral": [
    null,
    ""
  ],
  "Referral code": [
    null,
    ""
  ],
  "Region of birth": [
    null,
    "Provincia de nacimiento"
  ],
  "Register": [
    null,
    "Registrarse"
  ],
  "Register with my email": [
    null,
    "Registrarme con el correo"
  ],
  "Register with my phone number": [
    null,
    "Registrarme con el número de teléfono"
  ],
  "Registration": [
    null,
    "Registrarse"
  ],
  "Registration complete!": [
    null,
    ""
  ],
  "Registration not allowed from this country of residence.": [
    null,
    "No puedes registrarte desde este país de residencia"
  ],
  "Regular": [
    null,
    ""
  ],
  "Regular profile token": [
    null,
    ""
  ],
  "Residence permit: front and back": [
    null,
    "NIE: dos caras"
  ],
  "Responsible gaming": [
    null,
    "Juego responsable"
  ],
  "SWIFT code": [
    null,
    "Código SWIFT"
  ],
  "Save this card for future deposits": [
    null,
    "Guardar tarjeta para futuros depósitos"
  ],
  "Scan my ID": [
    null,
    "Escanear documento"
  ],
  "Scan my bank card": [
    null,
    "Escanear tarjeta "
  ],
  "Scan my verification document": [
    null,
    "Escanear documento"
  ],
  "Search": [
    null,
    "Buscar"
  ],
  "See Ts&Cs for the offer": [
    null,
    "Ver condiciones de la oferta"
  ],
  "See accepted verification documents": [
    null,
    "Ver los documentos aceptados"
  ],
  "See what IDs we accept": [
    null,
    "Ver los documentos aceptados"
  ],
  "Select your file": [
    null,
    "Seleccionar archivo"
  ],
  "Send ID": [
    null,
    "Enviar documento"
  ],
  "Send back of document": [
    null,
    "Subir parte trasera"
  ],
  "Send documents": [
    null,
    "Enviar documentos"
  ],
  "Send my ID": [
    null,
    "Enviar documento"
  ],
  "Send my new code": [
    null,
    "Enviadme un nuevo código"
  ],
  "Send my verification documents": [
    null,
    "Enviar documentos"
  ],
  "Send proof of identity": [
    null,
    "Enviar documento de identidad"
  ],
  "Sex": [
    null,
    "Sexo"
  ],
  "Show<br />us who<br />you are!": [
    null,
    "¡Demuestra<br />quién<br />eres!"
  ],
  "Skip this step": [
    null,
    "Saltar este paso"
  ],
  "Skrill email": [
    null,
    "Email Skrill"
  ],
  "Social security card": [
    null,
    "Tarjeta de seguridad social"
  ],
  "Sports betting Terms and Conditions": [
    null,
    "Reglamento de apuestas deportivas"
  ],
  "Starting at €%1$s": [
    null,
    "A partir de %1$s €"
  ],
  "Successfully uploaded!": [
    null,
    "¡Subido con éxito!"
  ],
  "Super-player created!": [
    null,
    "Superjugador creado."
  ],
  "Surname": [
    null,
    "Segundo apellido"
  ],
  "Take 2 minutes to create your account.": [
    null,
    "Crea tu cuenta en 2 minutos."
  ],
  "Tax Code": [
    null,
    "DNI/NIE"
  ],
  "Tax bill or home insurance letter": [
    null,
    "Justificante de impuestos o seguro del hogar"
  ],
  "Terms and Conditions": [
    null,
    "Términos y Condiciones"
  ],
  "The activation code cannot be over %1$s characters.": [
    null,
    "The activation code cannot be over %1$s characters.\n"
  ],
  "The activation code is not valid.": [
    null,
    "The activation code is not valid.\n"
  ],
  "The best odds are your odds": [
    null,
    "Las mejores cuotas"
  ],
  "The current process seems to be slow. Try again.": [
    null,
    "Parece que este proceso está tardando demasiado. Por favor, vuelve a intentarlo."
  ],
  "The identity verification service is unavailable. Please try again later.": [
    null,
    "El servicio de verificación de identidad no está disponible. Por favor, inténtalo más tarde."
  ],
  "The maximum amount of time (in hours) you can spend at the poker tables each week.": [
    null,
    ""
  ],
  "The maximum amount of your balance (bankroll) above which any additional winnings will be transferred directly to your bank account. Your account must be validated beforehand and we will need your bank details.": [
    null,
    ""
  ],
  "The maximum amount you can deposit into your account each week for sports betting and poker.": [
    null,
    ""
  ],
  "The maximum cumulative amount you can bet on poker each week.": [
    null,
    ""
  ],
  "The maximum cumulative amount you can bet on sports betting each week.": [
    null,
    ""
  ],
  "The welcome bonus is linked to your first deposit. Set an amount of €100 (or more) to maximise your bonus!": [
    null,
    ""
  ],
  "There already exists an account with this email address.": [
    null,
    "Ya existe una cuenta con este email"
  ],
  "These deposit methods are not available for this amount.": [
    null,
    "Este método no está disponible para esta cantidad."
  ],
  "This code is required to create your account.": [
    null,
    "Se necesita este código para crear la cuenta"
  ],
  "This field is mandatory to validate your deposit.": [
    null,
    "Este campo es obligatorio para validar el depósito."
  ],
  "This file format is invalid. Please try in one of the following formats: %1$s.": [
    null,
    "El formato del archivo es inválido. Por favor, prueba con uno de los siguientes formatos: %1$s."
  ],
  "This fiscal code is already linked to an active account": [
    null,
    "Tu DNI / NIE ya está siendo utilizado en una cuenta Winamax. Escribe al Soporte (soporte@winamax.es) si deseas reactivar tu cuenta."
  ],
  "This limit can be changed at any time in your account.": [
    null,
    ""
  ],
  "This limit is mandatory for your account validation.": [
    null,
    "Es obligatorio introducir un límite para validar la cuenta."
  ],
  "This password does not contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (e.g. @, !, #, $)": [
    null,
    "Esta contraseña no contiene al menos 3 de los caracteres siguientes: (0-9), (a-z), (A-Z) y símbolos (ex @, !, #, $)"
  ],
  "This referral code is not valid.": [
    null,
    ""
  ],
  "This threshold can be changed at any time from your account.": [
    null,
    ""
  ],
  "This username is unavailable.": [
    null,
    "Este nick no está disponible."
  ],
  "This way for<br />money": [
    null,
    "¡Enséñame<br />la pasta!"
  ],
  "Too many attempts with this identity. Please try again later.": [
    null,
    "Se han realizado demasiados intentos con una identidad errónea. Por favor, reinténtalo más tarde."
  ],
  "Try again": [
    null,
    "Reintentar"
  ],
  "Ts&Cs": [
    null,
    "TyC"
  ],
  "Ts&Cs for the offer": [
    null,
    "Condiciones de la oferta"
  ],
  "Type of cash-out": [
    null,
    "Tipo de retirada"
  ],
  "Type of document": [
    null,
    "Tipo de documento"
  ],
  "Unable to load profile information.": [
    null,
    "No hemos podido cargar los datos."
  ],
  "Unable to send verification message.": [
    null,
    "No se ha podido enviar el mensaje de verificación"
  ],
  "Unauthorised email.": [
    null,
    "Tu email no está autorizado."
  ],
  "Up to": [
    null,
    "Hasta"
  ],
  "Up to a limit of €100 or the same amount as your first deposit": [
    null,
    ""
  ],
  "Up to €100 free, instantly!": [
    null,
    "Primera apuesta reembolsada hasta 100 €"
  ],
  "Upload an identity document to continue registration.": [
    null,
    ""
  ],
  "Upload my ID": [
    null,
    "Subir el documento"
  ],
  "Upload my verification document": [
    null,
    "Subir el documento"
  ],
  "Use France Connect": [
    null,
    "Utilizar France Connect"
  ],
  "Use my existing deposit limit. If none is available, the limit set by you above will be applied.": [
    null,
    ""
  ],
  "Used or married name": [
    null,
    ""
  ],
  "Username": [
    null,
    "Nick"
  ],
  "Validate": [
    null,
    "Validar"
  ],
  "Validate my deposit": [
    null,
    "Validar el depósito"
  ],
  "Validate my information": [
    null,
    "Validar mis datos"
  ],
  "Validate my limit": [
    null,
    "Validar mi límite"
  ],
  "Validate my username": [
    null,
    "Validar el nick"
  ],
  "Validation code": [
    null,
    "Código de verificación"
  ],
  "Verification": [
    null,
    "Verificación"
  ],
  "Verify your phone number to receive a new text message with your validation code.": [
    null,
    "Comprueba tu número de teléfono para recibir un nuevo código de verificación por SMS."
  ],
  "Want to start playing? Make a deposit now.": [
    null,
    "¿Quieres empezar a jugar? Realiza ya un depósito."
  ],
  "Want to<br />create a<br />username?": [
    null,
    "¿Quieres<br />hacerte<br />un nombre?"
  ],
  "We are also offering a bonus of equal value to your first deposit.": [
    null,
    "Te ofrecemos un bono igual a tus primeros depósitos en Winamax"
  ],
  "We cannot accept land-line numbers.": [
    null,
    "No se aceptan teléfonos fijos."
  ],
  "We will refund your 1st bet up to €100.": [
    null,
    "Te reembolsamos tu primera apuesta hasta 100 €"
  ],
  "We're fetching your data...": [
    null,
    "Estamos extrayendo tus datos..."
  ],
  "Weekly betting limits": [
    null,
    ""
  ],
  "Welcome bonus": [
    null,
    ""
  ],
  "Welcome to Winamax": [
    null,
    ""
  ],
  "Welcome<br />to<br />Winamax!": [
    null,
    "¡Bienvenido<br />a<br />Winamax!"
  ],
  "What is France Connect": [
    null,
    "¿Qué es France Connect?"
  ],
  "With 168h per week, you can play for an unlimited period": [
    null,
    ""
  ],
  "Withdrawable cash credited to your account directly after the result of the first bet": [
    null,
    ""
  ],
  "You are already registered.": [
    null,
    ""
  ],
  "You are not authorized to access this service.": [
    null,
    "No es posible acceder a este servicio."
  ],
  "You are not permitted to create an account from this country.": [
    null,
    "No es posible crear una cuenta desde este país. "
  ],
  "You are not permitted to create this user account.": [
    null,
    "No es posible crear una cuenta."
  ],
  "You are on the Interior Ministry's banned player list!": [
    null,
    "Estás inscrito en el Registro General de Interdicciones de Acceso al Juego"
  ],
  "You can change this option at any time from your account": [
    null,
    "Puedes desinscribirte en cualquier momento desde tu cuenta"
  ],
  "You can continue playing on Winamax in the meantime.": [
    null,
    "Puedes seguir jugando en Winamax."
  ],
  "You can finally risk it for that big accumulator!": [
    null,
    "¡Juégatela a esa gran cuota!"
  ],
  "You can only upload one file at a time. Choose wisely!": [
    null,
    "Solo puedes subir un archivo."
  ],
  "You can send this to us at a later time, but you must enter your information now.": [
    null,
    "Puedes enviárnoslo más tarde, pero tienes que introducir los datos ahora."
  ],
  "You cannot create an account from your country.": [
    null,
    "No puedes crear una cuenta desde tu país"
  ],
  "You have already transferred this file.": [
    null,
    "Ya nos habías enviado este archivo"
  ],
  "You have entered an invalid domiciliation code": [
    null,
    "Has introducido un código de domicilación incorrecto"
  ],
  "You have entered an invalid phone number.": [
    null,
    "Has introducido un número de teléfono incorrecto"
  ],
  "You have insufficient CAPTCHA score to continue. Please try again later.": [
    null,
    "El resultado de CAPTCHA no es suficiente para continuar. Por favor, inténtalo de nuevo"
  ],
  "You have successfully added your identity document. Please ensure the information you have entered is correct and fill out your postal address.": [
    null,
    "Has añadido correctamente tu documento de identidad. Por favor, comprueba que la información es correcta y completa tu dirección postal."
  ],
  "You have successfully made a request to change your password. Please check your emails.": [
    null,
    ""
  ],
  "You must accept our Ts&Cs in order to create your account.": [
    null,
    "Debes aceptar nuestros TyC para crear tu cuenta."
  ],
  "You must choose a betting stakes limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose a deposit limit in order to make a deposit.": [
    null,
    "Debes elegir un límite de depósito para poder realizar uno."
  ],
  "You must choose a password.": [
    null,
    "Elige una contraseña."
  ],
  "You must choose a playtime limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose a poker stakes limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose an automatic withdrawal limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose an option for your sex in order to create your account.": [
    null,
    "Debes elegir una opción en \"sexo\" para poder crear la cuenta."
  ],
  "You must enter a deposit amount.": [
    null,
    "Debes introducir un importe"
  ],
  "You must enter an email or a phone number.": [
    null,
    "Introduce tu correo o número de teléfono."
  ],
  "You must enter the full name displayed on your bank card in order to validate your deposit.": [
    null,
    "Es obligatorio introducir el nombre del titular de la tarjeta para procesar el depósito"
  ],
  "You must enter your activation code in order to validate your account.": [
    null,
    "You must enter your activation code in order to validate your account.\n"
  ],
  "You must enter your bank card cryptogram in order to validate your deposit.": [
    null,
    "Es obligatorio introducir el CVV de la tarjeta para procesar el depósito"
  ],
  "You must enter your bank card expiry date in order to validate your deposit.": [
    null,
    "Es obligatorio introducir la fecha de caducidad de la tarjeta para procesar el depósito"
  ],
  "You must enter your bank card number in order to validate your deposit.": [
    null,
    "Es obligatorio introducir el número de la tarjeta para procesar el depósito"
  ],
  "You must enter your city of birth in order to create your account.": [
    null,
    "Debes introducir la ciudad de nacimiento para poder crear la cuenta."
  ],
  "You must enter your city of residence in order to create your account.": [
    null,
    "Debes introducir tu ciudad de residencia para poder crear la cuenta."
  ],
  "You must enter your country of birth in order to create your account.": [
    null,
    "Debes introducir tu país de nacimiento para poder crear la cuenta."
  ],
  "You must enter your country of residence in order to create your account.": [
    null,
    "Debes introducir tu país de residencia para poder crear la cuenta."
  ],
  "You must enter your date of birth in order to create your account.": [
    null,
    "Debes introducir tu fecha de nacimiento para poder crear la cuenta."
  ],
  "You must enter your department of birth in order to create your account.": [
    null,
    "Debes introducir tu región de nacimiento para poder crear tu cuenta."
  ],
  "You must enter your email in order to create your account.": [
    null,
    "Tienes que introducir tu correo para crear la cuenta"
  ],
  "You must enter your phone number in order to create your account.": [
    null,
    "Debes introducir tu número de teléfono para poder crear la cuenta"
  ],
  "You must enter your postal address in order to create your account.": [
    null,
    "Debes introducir tu dirección postal para poder crear la cuenta."
  ],
  "You must enter your postal code in order to create your account.": [
    null,
    "Debes introducir tu código postal para poder crear la cuenta."
  ],
  "You must enter your province to create your account.": [
    null,
    "Debes introducir tu provincia para poder crear la cuenta"
  ],
  "You must not be connected to the Winamax Poker software (desktop or mobile)": [
    null,
    "No debes estar conectado en el software Winamax Poker (ordenador, móvil y tablet)"
  ],
  "You must provide your first name in order to create your account.": [
    null,
    "Debes introducir tu nombre para poder crear la cuenta."
  ],
  "You must provide your last name in order to create your account.": [
    null,
    "Debes introducir los apellidos para poder crear la cuenta."
  ],
  "You must provide your second last name in order to create your account.": [
    null,
    "Necesitas introducir tu segundo apellido para crear tu cuenta."
  ],
  "You need a username to play on Winamax.": [
    null,
    "Necesitas un nick para jugar en Winamax"
  ],
  "You need to provide us with your ID and proof of address in order to complete your registration.": [
    null,
    "Debes enviarnos un documento de identidad y un justificante de domicilio para completar el registro."
  ],
  "You need to provide us with your ID in order to complete your registration.": [
    null,
    "Debes enviarnos un documento de identidad para completar tu registro"
  ],
  "You will receive an activation code by post at the following address:": [
    null,
    "You will receive an activation code by post at the following address:\n"
  ],
  "You're too old!": [
    null,
    "¡Eres demasiado viejo!"
  ],
  "You're too young!": [
    null,
    "¡Eres demasiado joven!"
  ],
  "You're way too young!": [
    null,
    "¡Eres demasiado joven!"
  ],
  "Your ID could not be analyzed but it has been registered. Please enter your information whilst waiting for your document to be verified.": [
    null,
    "No hemos podido reconocer tu documento pero se ha quedado guardado. Introduce tus datos mientras lo validamos."
  ],
  "Your ID upload has encountered an error": [
    null,
    "Se ha encontrado un error al subir tu documento"
  ],
  "Your ID was registered successfully": [
    null,
    "Tu documento de identidad ha sido registrado correctamente"
  ],
  "Your account is frozen.": [
    null,
    "Tu cuenta está bloqueada."
  ],
  "Your account is reloaded,<br /><b>you can continue playing on Winamax</b>": [
    null,
    "Las arcas vuelven a estar llenas,<br /><b>puedes seguir jugando en Winamax</b>"
  ],
  "Your account validation is being processed. You will be notified when your documents have been validated.": [
    null,
    "Tu cuenta está siendo validada. Recibirás una notificación cuando hayamos aceptado tus documentos."
  ],
  "Your address is not valid.": [
    null,
    "Tu dirección no es válida."
  ],
  "Your automatic withdrawal limit cannot be over %1$s digits.": [
    null,
    "Tu límite de reintegro automático no puede ser superior a %1$s dígitos."
  ],
  "Your automatic withdrawal limit is too big.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be greater than or equal to your deposit limit.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be more than €200.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be over €0.": [
    null,
    "Tu límite de retirada automático debe ser superior a 0 €"
  ],
  "Your bank card cryptogram is not valid.": [
    null,
    "El CVV de la tarjeta no es válido"
  ],
  "Your bank card expiry date is not valid.": [
    null,
    "La fecha de caducidad de la tarjeta no es válida"
  ],
  "Your bank card number is not valid": [
    null,
    "El número de tarjeta no es válido"
  ],
  "Your bet refunded in": [
    null,
    ""
  ],
  "Your betting stakes limit is too big.": [
    null,
    ""
  ],
  "Your betting stakes limit must be more than €0.": [
    null,
    ""
  ],
  "Your betting stakes limit per week is not valid.": [
    null,
    "Tu límite de apuestas semanal no es válido."
  ],
  "Your city cannot be over %1$s characters.": [
    null,
    "La ciudad no puede superar los %1$s caracteres."
  ],
  "Your city is not valid.": [
    null,
    "La ciudad no es válida."
  ],
  "Your city is required.": [
    null,
    "Necesitas introducir la ciudad."
  ],
  "Your city of birth cannot be over %1$s characters.": [
    null,
    "La ciudad de nacimiento no puede superar los %1$s caracteres."
  ],
  "Your city of birth is not valid.": [
    null,
    "La ciudad de nacimiento no es válido"
  ],
  "Your coordinates": [
    null,
    "Tus datos"
  ],
  "Your country cannot be over %1$s characters.": [
    null,
    "El país no puede superar los %1$s caracteres."
  ],
  "Your country is not valid.": [
    null,
    "El país no es válido"
  ],
  "Your country is required.": [
    null,
    "Necesitas introducir el país."
  ],
  "Your country of birth is not valid.": [
    null,
    "El país de nacimiento no es válido"
  ],
  "Your date of birth is not valid.": [
    null,
    "La fecha de nacimiento no es válida"
  ],
  "Your date of birth must include 4 numbers.": [
    null,
    "Tu fecha de nacimiento debe seguir el siguiente formato: DD/MM/AAAA"
  ],
  "Your department of birth cannot be over %1$s characters.": [
    null,
    "Tu región de nacimiento no puede superar los %1$s caracteres."
  ],
  "Your department of birth is not valid.": [
    null,
    "Tu región de nacimiento no es válida."
  ],
  "Your deposit cannot be more than your weekly deposit limit: €%1$s.": [
    null,
    "Tu depósito no puede ser superior a tu límite semanal: %1$s €."
  ],
  "Your deposit limit has been registered. <b>in 48 hours, you will be able to make larger deposits</b>": [
    null,
    "Tu límite de depósito ha sido registrado. <b> Podrás hacer depósitos más grandes en 48 horas</b>"
  ],
  "Your deposit limit is too big.": [
    null,
    "Límite de depósito demasiado alto."
  ],
  "Your deposit limit must be more than €0.": [
    null,
    "Tu límite de depósito debe ser superior a 0 €"
  ],
  "Your deposit limit per week is not valid.": [
    null,
    "Tu límite de depósito semanal no es válido."
  ],
  "Your deposit must be over €0.": [
    null,
    "Tu depósito debe ser superior a 0 €"
  ],
  "Your document failed to upload": [
    null,
    "No se ha podido subir el documento"
  ],
  "Your email cannot be over %1$s characters.": [
    null,
    "Tu correo no puede superar los %1$s caracteres."
  ],
  "Your email is not valid.": [
    null,
    "Tu correo no es válido."
  ],
  "Your file is too big. Try again with a file smaller than %1$s Mb.": [
    null,
    "El archivo es demasiado grande. Prueba con un archivo menor de %1$s Mb."
  ],
  "Your first bet refunded in cash if it loses": [
    null,
    ""
  ],
  "Your first name cannot be over %1$s characters.": [
    null,
    "Tu nombre no puede superar los %1$s caracteres."
  ],
  "Your first name is not valid.": [
    null,
    "El nombre no es válido"
  ],
  "Your identity": [
    null,
    "Tu identidad"
  ],
  "Your identity corresponds to that of a minor.": [
    null,
    "Tu identidad corresponde a la de una persona menor de edad."
  ],
  "Your identity corresponds to that of someone who has been registered as being deceased.": [
    null,
    "Tu identidad corresponde a la de una persona registrada como fallecida."
  ],
  "Your information is being processed!": [
    null,
    "¡Tu información ha sido procesada!"
  ],
  "Your initial deposit in Freebets, up to €100*": [
    null,
    ""
  ],
  "Your last name cannot be over %1$s characters.": [
    null,
    "Tus apellidos no pueden superar los %1$s caracteres."
  ],
  "Your last name is not valid.": [
    null,
    "El apellido no es válido"
  ],
  "Your limit cannot be €0": [
    null,
    "El límite no puede ser 0 €"
  ],
  "Your limit for %1$s must be inferior or equal to %2$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be set between %2$s and %3$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be superior or equal to %2$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be superior or equal to your %2$s limit": [
    null,
    ""
  ],
  "Your limit must be inferior or equal to %1$s": [
    null,
    "Tu límite debe de ser inferior o igual a %1$s"
  ],
  "Your limit must be set between %1$s and %2$s": [
    null,
    "Tu límite debe estar entre %1$s y %2$s"
  ],
  "Your limit must be superior or equal to %1$s": [
    null,
    "Tu límite debe ser superior o igual a %1$s"
  ],
  "Your name in the rankings will be:": [
    null,
    ""
  ],
  "Your number will only be used to identify you": [
    null,
    ""
  ],
  "Your password cannot be over %1$s characters.": [
    null,
    "Tu contraseña no puede superar los %1$s caracteres."
  ],
  "Your password is not valid.": [
    null,
    "Tu contraseña no es válida."
  ],
  "Your password must contain at least %1$s characters.": [
    null,
    "Tu contraseña debe contener al menos %1$s caracteres."
  ],
  "Your payment": [
    null,
    "Tu pago"
  ],
  "Your phone number is mandatory in order to receive a new code.": [
    null,
    "Necesitas introducir tu número de teléfono para recibir un nuevo código"
  ],
  "Your playtime limit must be more than 0 hours.": [
    null,
    ""
  ],
  "Your poker stakes limit is too big.": [
    null,
    ""
  ],
  "Your poker stakes limit must be more than €0.": [
    null,
    ""
  ],
  "Your poker stakes limit per week is not valid.": [
    null,
    "Tu límite de póker semanal no es válido."
  ],
  "Your postal address cannot be over %1$s characters.": [
    null,
    "Tu dirección postal no puede superar los %1$s caracteres."
  ],
  "Your postal address is required.": [
    null,
    "Necesitas introducir tu dirección postal."
  ],
  "Your postal code cannot be over %1$s characters.": [
    null,
    "El código postal no puede superar los %1$s caracteres."
  ],
  "Your postal code is required.": [
    null,
    "Necesitar introducir tu código postal."
  ],
  "Your proof of address cannot be over one year old.": [
    null,
    "La fecha de emisión del documento no puede ser superior a un año."
  ],
  "Your session has expired.": [
    null,
    "Tu sesión ha expirado."
  ],
  "Your state is not valid.": [
    null,
    "Tu región no es válida."
  ],
  "Your story begins here!": [
    null,
    ""
  ],
  "Your turn to play": [
    null,
    "¡Tu turno!"
  ],
  "Your turn<br />to play": [
    null,
    "Tu turno"
  ],
  "Your username cannot contain over %1$s characters.": [
    null,
    "El nick no debe contener más de %1$s caracteres."
  ],
  "Your username is not valid, the only authorized special characters are: .&_- and space.": [
    null,
    "Tu nick no es válido. Los únicos caracteres especiales autorizados son: .&_- y el espacio."
  ],
  "Your username must contain at least %1$s characters.": [
    null,
    "El nick debe contener al menos %1$s caracteres."
  ],
  "Your validation code is incorrect.": [
    null,
    "Tu código de validación es incorrecto."
  ],
  "Your zip code is not valid.": [
    null,
    "Tu código postal no es válido."
  ],
  "Your zip code of birth is not valid.": [
    null,
    "Tu código postal de nacimiento no es válido."
  ],
  "and": [
    null,
    "y"
  ],
  "as well as our": [
    null,
    "así como nuestra"
  ],
  "is being processed...": [
    null,
    "está siendo procesado..."
  ],
  "of a super-player in progress...": [
    null,
    "superjugador..."
  ],
  "of the ongoing payment...": [
    null,
    "del pago en curso..."
  ],
  "of your bank card processing...": [
    null,
    "tarjeta..."
  ],
  "or": [
    null,
    "o"
  ],
  "poker": [
    null,
    ""
  ],
  "promotions": [
    null,
    ""
  ],
  "sports betting": [
    null,
    "apuestas"
  ],
  "your document upload...": [
    null,
    "el documento..."
  ]
}
  }
}
